import { render, staticRenderFns } from "./FeatureRequestCard.vue?vue&type=template&id=59853fe4&scoped=true&"
import script from "./FeatureRequestCard.vue?vue&type=script&lang=js&"
export * from "./FeatureRequestCard.vue?vue&type=script&lang=js&"
import style0 from "./FeatureRequestCard.vue?vue&type=style&index=0&id=59853fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59853fe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59853fe4')) {
      api.createRecord('59853fe4', component.options)
    } else {
      api.reload('59853fe4', component.options)
    }
    module.hot.accept("./FeatureRequestCard.vue?vue&type=template&id=59853fe4&scoped=true&", function () {
      api.rerender('59853fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeatureRequests/FeatureRequestCard.vue"
export default component.exports